import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@mui/material";

import { categories } from "../../../data/category.js";
import { useOutletContext } from "react-router-dom";
import { useGetStockInfoQuery } from "../../../redux/slices/seller/products/stockInfoSlice.js";
import { Pagination } from "@mui/material";
import "../../../styles/seller.css/products-css/stock-info.css";

export default function StockInfo() {
    const { sidebarOpen } = useOutletContext();
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;

    const { data, isLoading, error, refetch } = useGetStockInfoQuery();
    const products = data?.data || [];

    const [search, setSearch] = useState("");
    const [category, setCategory] = useState("Hamısı");
    const [subCategory, setSubCategory] = useState("Hamısı");
    const [quantityFilter, setQuantityFilter] = useState("Hamısı");

    useEffect(() => {
        refetch();
    }, []);

    const filtered = products
        .filter((p) => {
            const s = search.toLowerCase();
            const matchCategory = category === "Hamısı" || p.categoryName === category;
            const matchSubCategory = subCategory === "Hamısı" || p.subcategoryName === subCategory;
            const matchSearch = p.name.toLowerCase().includes(s);
            return matchCategory && matchSubCategory && matchSearch;
        })
        .sort((a, b) => {
            if (quantityFilter === "Azdan Çoxa") return a.quantity - b.quantity;
            if (quantityFilter === "Çoxdan Aza") return b.quantity - a.quantity;
            return 0;
        });

    const getTableHeaders = () => {

        if (subCategory === "Hava filtiri" || subCategory === "Yağ filtiri" || subCategory === "Benzin filtiri" || subCategory === "Salon filtiri" || subCategory === "Transmissiya filtiri") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növü", "Miqdar", "Kod", "Qiymət"];
        } else if (subCategory === "Motor yağı" || subCategory === "Transmissiya yağı") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növü", "Miqdar", "Litr", "Cəm Litr", "Kod", "Qiymət"];
        } else if (subCategory === "Antifriz") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Yanacaq Növü", "Miqdar", "Rəng", "Litr", "Kod", "Qiymət"];
        }
        else if (subCategory === "Əyləc mayesi") {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Miqdar", "Litr", "Cəm Litr", "Qiymət"];
        }
        else {
            return ["#No", "Məhsul Adı", "Kateqoriya", "Alt-kateqoriya", "Miqdar", "Qiymət"];
        }
    };

    const renderTableCell = (prod, header, index) => {
        switch (header) {
            case "#No":
                return "#" + String(prod.serialNo || prod.id).padStart(4, "0");
            case "Məhsul Adı":
                return prod.name;
            case "Kateqoriya":
                return prod.categoryName;
            case "Alt-kateqoriya":
                return prod.subcategoryName;
            case "Yanacaq Növü":
                return prod.fuelType || "-";
            case "Miqdar":
                return ["Motor yağı", "Transmissiya yağı"].includes(prod.subcategoryName)
                    ? Math.ceil(parseFloat(prod.quantity))
                    : prod.quantity;
            case "Litr":
                return prod.liter + "L" || "-";
            case "Cəm Litr":
                return prod.totalLiter + "L" || "-";
            case "Kod":
                return prod.code || "-";
            case "Rəng":
                return String(prod.color) || "-";
            case "Qiymət":
                return prod.sellPrice + "₼";
            default:
                return "";
        }
    };

    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedProducts = filtered.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        setPage(1);
    }, [search, category, subCategory, quantityFilter]);




    return (
        <Box className={`stock-info-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="stock-info-header">
                <Box className="stock-info-title">
                    <Typography style={{ color: "#545A61" }}>Məhsulların idarə edilməsi</Typography>
                    <Divider className="stock-info-divider" />
                </Box>

                <Box className="stock-info-filters-row">
                    <Box style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                        <FormControl size="small" className="select-stockinfo-category">
                            <InputLabel>Kateqoriya seçim</InputLabel>
                            <Select
                                label="Kateqoriya seçim"
                                value={category}
                                onChange={(e) => { setCategory(e.target.value); setSubCategory("Hamısı"); }}
                                style={{ width: 150 }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 300,
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                    getContentAnchorEl: null,
                                }}
                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                {categories.map((c, i) => (
                                    <MenuItem key={i} value={c.category}>{c.category}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" className="select-stockinfo-category">
                            <InputLabel>Alt-kateqoriya</InputLabel>
                            <Select
                                label="Alt-kateqoriya"
                                value={subCategory}
                                onChange={(e) => setSubCategory(e.target.value)}
                                style={{ width: 150 }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: 300,
                                        },
                                    },
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                    },
                                    getContentAnchorEl: null,
                                }}
                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                {categories.find((c) => c.category === category)?.subCategories.map((sc, i) => (
                                    <MenuItem key={i} value={sc.name}>{sc.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" className="select-stockinfo-category">
                            <InputLabel>Miqdar</InputLabel>
                            <Select
                                label="Miqdar"
                                value={quantityFilter}
                                onChange={(e) => setQuantityFilter(e.target.value)}
                                style={{ minWidth: 150 }}

                            >
                                <MenuItem value="Hamısı">Hamısı</MenuItem>
                                <MenuItem value="Azdan Çoxa">Azdan Çoxa</MenuItem>
                                <MenuItem value="Çoxdan Aza">Çoxdan Aza</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <TextField
                        size="small"
                        placeholder="Axtar..."
                        className="stock-info-search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Box>
            </Box>

            {/* TABLE */}
            <TableContainer component={Paper} className="stock-info-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            {getTableHeaders().map((header, i) => (
                                <TableCell key={i}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={getTableHeaders().length} align="center">
                                    Yüklənir...
                                </TableCell>
                            </TableRow>
                        ) : paginatedProducts.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={getTableHeaders().length} align="center">
                                    Məlumat tapılmadı
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedProducts.map((prod, index) => (
                                <TableRow key={prod.id}>
                                    {getTableHeaders().map((header, i) => (
                                        <TableCell key={i}>
                                            {renderTableCell(prod, header, index)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filtered.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);

                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
}
